<template>
  <div class="form-quizz-basic-info-component">
    <div class="warning-card">
      <i class="ph ph-warning-circle" />
      <div class="d-flex flex-column">
        <h5>Atenção</h5>
        <small class="text-dark-40 fs-12">
          Caso não tenha habilitado avaliação no processo de certificação,
          revise suas configurações em ‘Configurar Certificado’
        </small>
      </div>
    </div>
    <snow-input
      v-model="form.title"
      id="name"
      label="Nome da avaliação"
      :errors="errors.title"
      required
    />
    <snow-input
      v-model="form.description"
      id="orientations"
      label="Orientações"
      type="textarea"
      :errors="errors.description"
      rows="5"
      required
    />
    <div class="pt-4">
      <h5 class="text-semibold">Configurações avançadas</h5>
      <h6 class="text-dark-40">
        Estas configurações são opcionais, configure como preferir
      </h6>
    </div>

    <snow-switch
      v-model="time_limit_enable"
      id="time_limit_enable"
      label="Determinar o tempo para realização da avaliação"
    />
    <div v-if="time_limit_enable">
      <snow-input
        v-model="form.time_limit_minutes"
        :errors="errors.time_limit_minutes"
        id="time_limit_minutes"
        mask="###########"
        label="Tempo em minutos"
        :maxNumber="600"
        required
      />
    </div>
    <snow-switch
      v-model="average_enable"
      id="average_enable"
      label="Determinar uma média para aprovação"
      info="O Gabarito será liberado somente após atingir essa média"
    />
    <div v-if="average_enable">
      <snow-input
        v-model="form.approval_average"
        :errors="errors.approval_average"
        id="approval_average"
        type="number"
        label="Média em %"
        :maxNumber="100"
        required
      />
    </div>

    <snow-switch
      v-model="form.allow_reveal_answer_keys"
      id="allow_reveal_answer_keys"
      label="Liberar gabarito quando atingir média"
    />

    <snow-switch
      v-model="retry_enable"
      id="retry_enable"
      label="Liberar novas tentativas"
    />

    <div v-if="retry_enable">
      <snow-input
        v-model="form.number_of_attempts"
        :errors="errors.number_of_attempts"
        id="number_of_attempts"
        type="number"
        :maxNumber="100"
        required
      />
    </div>

    <div class="pt-4">
      <h5 class="text-semibold">Liberação da avaliação</h5>
      <h6 class="text-dark-40">
        Determine quando a avaliação será liberada.
      </h6>
    </div>

    <snow-switch
      v-if="isFinal"
      v-model="form.release_final_quiz_when_finished"
      id="release_final_quiz_when_finished"
      label="Liberar a avaliação após o término de todas as aulas do curso"
    />

    <snow-switch
      v-model="days_to_relase_enable"
      id="days_count_enable"
      label="Liberar para quantidade de dias"
    />

    <div v-if="days_to_relase_enable">
      <snow-input
        v-model="form.days_to_release"
        :errors="errors.days_to_release"
        id="days_to_release"
        type="number"
        placeholder="0 dias"
        :maxNumber="999"
        required
      />
    </div>

    <snow-switch
      v-model="release_at_enable"
      id="release_at_enable"
      label="Liberar em uma data especifica"
    />

    <div v-if="release_at_enable">
      <snow-date-picker
        v-model="form.release_at"
        label="Selecionar data"
        single
        format="YYYY-MM-DD"
        size="lg"
      />
    </div>
  </div>
</template>

<script>
import MemberAreaMixin from "@/mixins/memberArea.js";

export default {
  mixins: [MemberAreaMixin],
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    isFinal: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    cancel_label() {
      if (
        [
          "product-members-module-quizz-final-edit",
          "product-members-module-quizz-edit"
        ].includes(this.$route.name)
      ) {
        return "Voltar";
      }

      return "Cancelar";
    }
  },
  data() {
    return {
      time_limit_enable: this.form?.time_limit_minutes > 0,
      average_enable: this.form?.approval_average > 0,
      retry_enable: this.form?.number_of_attempts > 0,
      days_to_relase_enable: this.form?.days_to_release > 0,
      release_at_enable: !!this.form.release_at,
      loading: false
    };
  },
  watch: {
    form: {
      immediate: true,
      handler(value) {
        if (value?.time_limit_minutes > 0) {
          this.time_limit_enable = true;
        } else {
          this.form.time_limit_minutes = 0;
        }

        if (value?.approval_average > 0) {
          this.average_enable = true;
        } else {
          this.form.approval_average = 0;
        }

        if (value?.number_of_attempts > 0) {
          this.retry_enable = true;
        } else {
          this.form.number_of_attempts = 0;
        }

        if (value?.days_to_release > 0) {
          this.days_to_relase_enable = true;
          this.release_at_enable = false;
        } else {
          this.form.days_to_release = 0;
        }

        if (value?.release_at && value?.release_at.length > 0) {
          this.release_at_enable = true;
          this.days_to_relase_enable = false;
        } else {
          this.form.release_at = "";
        }
      }
    },
    release_at_enable(value) {
      if (value) {
        this.days_to_relase_enable = false;
      } else {
        this.form.release_at = "";
      }
    },
    days_to_relase_enable(value) {
      if (value) {
        this.release_at_enable = false;
      } else {
        this.form.days_to_release = 0;
      }
    },
    retry_enable(value) {
      if (!value) {
        this.form.number_of_attempts = 0;
      }
    },
    average_enable(value) {
      if (!value) {
        this.form.approval_average = 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-quizz-basic-info-component {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
